/* ============================================================
   LED Sign City — home page behaviour
   Vanilla JS, no dependencies. Safe to load with `defer`.
   Two things only: carousel (drag + arrows) and booking modal.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lscReady === '1') return;
    root.dataset.lscReady = '1';

    /* ---------- CAROUSELS ---------- */
    var rails = root.querySelectorAll('.lsc-rail');

    Array.prototype.forEach.call(rails, function (rail) {
      // Pointer drag — mouse and pen only. Touch already scrolls natively,
      // and hijacking it breaks vertical page scroll on phones.
      var down = false, startX = 0, startLeft = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
      });

      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) rail.classList.add('is-drag');
        rail.scrollLeft = startLeft - dx;
      });

      function release() {
        down = false;
        // Defer so the click that ends a drag is swallowed, not followed.
        setTimeout(function () { rail.classList.remove('is-drag'); }, 0);
      }
      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointerleave', release);
      rail.addEventListener('pointercancel', release);

      // Arrow enable/disable
      var nav = root.querySelector('[data-lsc-railnav="' + rail.id + '"]');
      if (nav) {
        var prev = nav.querySelector('[data-lsc-dir="-1"]');
        var next = nav.querySelector('[data-lsc-dir="1"]');
        var sync = function () {
          var max = rail.scrollWidth - rail.clientWidth - 2;
          if (prev) prev.disabled = rail.scrollLeft <= 2;
          if (next) next.disabled = rail.scrollLeft >= max;
        };
        rail.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      }
    });

    // Arrow clicks — delegated, so it works no matter how many rails there are.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-lsc-dir]') : null;
      if (!btn) return;
      var rail = document.getElementById(btn.getAttribute('data-lsc-rail'));
      if (!rail) return;
      var first = rail.firstElementChild;
      var step = (first ? first.getBoundingClientRect().width : 271) + 18;
      rail.scrollBy({ left: step * Number(btn.getAttribute('data-lsc-dir')), behavior: 'smooth' });
    });

    /* ---------- BOOKING MODAL ---------- */
    var modal = root.querySelector('[data-lsc-modal]');
    if (!modal) return;

    var iframe = modal.querySelector('iframe');
    var src = iframe ? iframe.getAttribute('data-src') : null;
    var lastFocus = null;

    function open(e) {
      if (e && e.preventDefault) e.preventDefault();
      lastFocus = document.activeElement;
      // Load the calendar on first open, not on page load — it is a heavy
      // third-party embed and most visitors never open it.
      if (iframe && src && !iframe.getAttribute('src')) iframe.setAttribute('src', src);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = modal.querySelector('.lsc-modal__x');
      if (x) x.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-lsc-book]'), function (b) {
      b.addEventListener('click', open);
    });

    modal.addEventListener('click', function (e) {
      // Backdrop click closes; clicks inside the panel do not.
      if (e.target === modal || (e.target.closest && e.target.closest('[data-lsc-close]'))) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.lsc-home'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections without a page reload.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.lsc-home') : null;
    if (el) init(el);
  });
})();
